<ion-col class="flex-align-center">
    <ion-grid>
        <ion-row>
            <ion-col size="12" class="ion-text-center">
                <h3>Configurações de Campanhas</h3>
            </ion-col>
        </ion-row>

        <ion-row *ngFor="let item of config?.ConfigList">

            <ion-col size="12">
                <ion-card>
                    <ion-card-header>
                        <ion-card-title> {{ item?.Campaign?.Name || 'Sem Campanha' }} </ion-card-title>
                    </ion-card-header>
                    <ion-card-content>
        
                        <ion-row>
                            <ion-col size="6"><strong>Módulo:</strong></ion-col>
                            <ion-col size="6">{{ item?.Module?.Name }}</ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col size="6"><strong>Estado:</strong></ion-col>
                            <ion-col size="6">{{ item?.Status ? 'Ativo' : 'Inativo' }}</ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col size="6"><strong>Valor Mínimo Fatura:</strong></ion-col>
                            <ion-col size="6">{{ item?.MinimumInvoiceValue }}</ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col size="6"><strong>Benefício:</strong></ion-col>
                            <ion-col size="6">
                                {{ item?.BenefitValue }} {{ item?.BenefitValueInPercentage ? '%' : '' }}
                                (Moeda: {{ item?.BenefitCurrency }})
                            </ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col size="6"><strong>Validade (dias):</strong></ion-col>
                            <ion-col size="6">{{ item?.CampaignValidationDays }}</ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col size="6"><strong>Vouchers Disponíveis:</strong></ion-col>
                            <ion-col size="6">
                                {{ item?.MaxAvailableVouchersToIssue }} (Total) /
                                {{ item?.MaxAvailableVouchersByUser }} (por utilizador)
                            </ion-col>
                        </ion-row>
                    </ion-card-content>
                </ion-card>
            </ion-col>

        </ion-row>
    </ion-grid>
</ion-col>